
// import React, { useState, useEffect, useMemo } from "react";
// import axios from "axios";
// import { BASE_URL, IMAGE_URL } from "../../config/axios";
// import {
//   CustomImageModal,
//   CustomTooltip,
//   handleErrorToast,
//   SearchFilterInput,
//   UserProfileModal,
// } from "../CustomFunctions";
// import Modal from "react-bootstrap/Modal";
// import {
//   ProjectAdd,
//   ProjectClientAdd,
//   ProjectClientDelete,
//   ProjectClientUpdate,
//   ProjectClientBulkUpload,
//   ProjectDelete,
//   ProjectTypeAdd,
//   ProjectTypeDelete,
//   ProjectTypeUpdate,
//   ProjectTypeBulkUpload,
//   ProjectUpdate,
//   ProjectBulkUpload,
// } from "./ProjectDetailsComponents";
// import usePermission from "../../config/permissions";
// import { ToastContainer, toast } from "react-toastify";
// import UserDefaultLogo from "../UserDetails/UserDefaultLogo";
// import { formatDate, formatDateTime } from "../Date";
// import { SearchBig } from "../AllSvg";

// // ===================== MAIN TABLE COMPONENT =====================

// const ProjectDetailTable = () => {
//     // const [projectDetail, setProjectDetail] = useState([]);
//     const [allProjects, setAllProjects] = useState([]);
//     const { SUB_COMPANIES, PERMISSION_AUTHORITY } = usePermission();
//     const [toggleCompany, setToggleCompany] = useState("null");
//     const [buffer, setBuffering] = useState(true); //buffering logic
//     const [toggleDepartment, setToggleDepartment] = useState("null");
//     const [departmentList, setDepartmentList] = useState([]);
//     const [searchQuery, setSearchQuery] = useState("");

//     // ================= FILTER STATES =================
//     const [projectName, setProjectName] = useState("");
//     const [projectType, setProjectType] = useState("");
//     const [projectCode, setProjectCode] = useState("");
//     const [clientName, setClientName] = useState("");

//     const projectDetail = useMemo(() => {
//         if (!toggleDepartment || toggleDepartment === "null") return allProjects;
//         return allProjects.filter((p) => p.department === toggleDepartment);
//     }, [allProjects, toggleDepartment]);

//     // ================= FILTERED PROJECT DATA =================
//     // ================= FILTERED PROJECT DATA =================

//     const filteredProjects = useMemo(() => {

//         let filteredData = [...projectDetail];



//         // ================= PROJECT NAME =================
//         if (projectName?.trim()) {

//             filteredData = filteredData.filter((i) =>
//                 (i?.project_short_name || "")
//                     .toLowerCase()
//                     .includes(projectName.toLowerCase().trim())
//             );
//         }



//         // ================= PROJECT TYPE =================
//         if (projectType?.trim()) {

//             filteredData = filteredData.filter((i) =>
//                 (i?.project_type_name || "")
//                     .toLowerCase()
//                     .includes(projectType.toLowerCase().trim())
//             );
//         }



//         // ================= PROJECT CODE =================
//         if (projectCode?.trim()) {

//             filteredData = filteredData.filter((i) =>
//                 (i?.project_code || "")
//                     .toLowerCase()
//                     .includes(projectCode.toLowerCase().trim())
//             );
//         }



//         // ================= CLIENT NAME =================
//         if (clientName?.trim()) {

//             filteredData = filteredData.filter((i) =>
//                 (i?.project_client_detail?.client_name || "")
//                     .toLowerCase()
//                     .includes(clientName.toLowerCase().trim())
//             );
//         }



//         return filteredData;

//     }, [
//         projectDetail,
//         projectName,
//         projectType,
//         projectCode,
//         clientName
//     ]);


//     //  Fetch departments (filtered by sub-company if selected)
//     // const getDepartmentList = async (subCompanyId) => {
//     //     try {
//     //         const url =
//     //             subCompanyId && subCompanyId !== "null"
//     //                 ? `${BASE_URL}/wfm/departmentfilterbysubcompanycount/${subCompanyId}/active/`
//     //                 : `${BASE_URL}/wfm/departmentfilterbysubcompanycount/null/null/`;
//     //         const res = await axios.get(url);
//     //         setDepartmentList(res.data);
//     //     } catch (err) {
//     //         handleErrorToast(err);
//     //     }
//     // };
//     const getProjectDetailList = async () => {
//         try {
//             setBuffering(true);
//             const params = new URLSearchParams();
//             if (toggleCompany && toggleCompany !== "null")
//                 params.append("sub_company_id", toggleCompany);
//             // if (toggleDepartment && toggleDepartment !== "null")
//             //     params.append("department_id", toggleDepartment);

//             const res = await axios.get(
//                 `${BASE_URL}/mantra_projects/projects/${params.toString() ? `?${params.toString()}` : ""}`
//             );
//             // setProjectDetail(res.data);
//             setAllProjects(res.data);
//         } catch (err) {
//             handleErrorToast(err)
//         } finally {
//             setBuffering(false); //buffering logic // End Buffering
//         }
//     };

//     const departmentOptions = useMemo(() => {
//         const seen = new Set();
//         return allProjects
//             ?.filter((p) => p.department && p.department_name)
//             ?.filter((p) => {
//                 if (seen.has(p.department)) return false;
//                 seen.add(p.department);
//                 return true;
//             })
//             .sort((a, b) => a.department_name.localeCompare(b.department_name));
//     }, [allProjects]);


//     const handleCompanyChange = (e) => {
//         const val = e.target.value;
//         setToggleCompany(val);
//         setToggleDepartment("null");
//         // getDepartmentList(val);
//     };
//     // useEffect(() => {
//     //     getDepartmentList("null");
//     // }, [toggleCompany]);

//     useEffect(() => {
//         getProjectDetailList();
//     }, [toggleCompany]);



//     return (
//         <>
//             <div className="content-tabs" style={{ margin: '10px' }}>


//                 <div
//                     className="field-parent-cont"
//                     style={{ gap: '20px' }}
//                 >

//                     <div className="field-cont">

//                         {/* SUB COMPANY */}
//                         {PERMISSION_AUTHORITY && (

//                             <div className="field-cont-div">

//                                 <select
//                                     onChange={handleCompanyChange}
//                                     value={toggleCompany}
//                                     className="attendance-input-field width-12vw"
//                                 >

//                                     <option value="null">
//                                         All Sub Companies
//                                     </option>

//                                     {SUB_COMPANIES.map((company) => (
//                                         <option
//                                             key={company.id}
//                                             value={company.id}
//                                         >
//                                             {company.title}
//                                         </option>
//                                     ))}

//                                 </select>

//                                 <hr className="field-cont-hr" />

//                             </div>

//                         )}



//                         {/* DEPARTMENT */}
//                         <div className="field-cont-div">

//                             <select
//                                 onChange={(e) => setToggleDepartment(e.target.value)}
//                                 value={toggleDepartment}
//                                 className="attendance-input-field width-12vw"
//                             >

//                                 <option value="null">
//                                     All Departments
//                                 </option>

//                                 {departmentOptions.map((p) => (
//                                     <option
//                                         key={p.department}
//                                         value={p.department}
//                                     >
//                                         {p.department_name}
//                                     </option>
//                                 ))}

//                             </select>

//                             <hr className="field-cont-hr" />

//                         </div>



//                         {/* PROJECT NAME */}
//                         <SearchFilterInput
//                             placeholder="By Project Name"
//                             value={projectName}
//                             onChange={(e) =>
//                                 setProjectName(e.target.value)
//                             }
//                             onClear={() => setProjectName("")}
//                             widthClass="width-16vw"
//                         />



//                         {/* ================= PROJECT TYPE ================= */}

//                         <SearchFilterInput
//                             placeholder="By Project Type"
//                             value={projectType}
//                             onChange={(e) =>
//                                 setProjectType(e.target.value)
//                             }
//                             onClear={() => setProjectType("")}
//                             widthClass="width-14vw"
//                         />



//                         {/* ================= PROJECT CODE ================= */}

//                         <SearchFilterInput
//                             placeholder="By Project Code"
//                             value={projectCode}
//                             onChange={(e) =>
//                                 setProjectCode(e.target.value)
//                             }
//                             onClear={() => setProjectCode("")}
//                             widthClass="width-14vw"
//                         />



//                         {/* ================= CLIENT NAME ================= */}

//                         <SearchFilterInput
//                             placeholder="By Client Name"
//                             value={clientName}
//                             onChange={(e) =>
//                                 setClientName(e.target.value)
//                             }
//                             onClear={() => setClientName("")}
//                             widthClass="width-16vw"
//                         />

//                     </div>


//                     {/* RIGHT BUTTONS */}
//                     <div
//                         className="letter-template-btn"
//                         style={{
//                             display: 'flex',
//                             gap: '10px'
//                         }}
//                     >

//                         <ProjectAdd getProjects={getProjectDetailList} SUB_COMPANIES={SUB_COMPANIES} />

//                         {/* <ProjectBulkUpload getProjects={getProjectDetailList} SUB_COMPANIES={SUB_COMPANIES} /> */}
//                         <ProjectBulkUpload getProjects={getProjectDetailList} SUB_COMPANIES={SUB_COMPANIES} selectedCompany={toggleCompany} />

//                     </div>


//                 </div>


//                 <div className="table-css-white-background">
//                     <div className="table-heading-flex">

//                         <div className="repo-heading font-weight500 font-size-heading">
//                             Project Details
//                         </div>
//                     </div>

//                     <table className="table-css">
//                         <thead>
//                             <tr className="custom-table-head-tr">
//                                 <th className="align-left">Sr no</th>
//                                 <th className="align-center">Company</th>
//                                 <th className="align-center">Department</th>
//                                 <th className="align-center">Project Code</th>
//                                 <th className="align-center">Project Name</th>
//                                 <th className="align-center">Project Type</th>
//                                 <th className="align-center">Client Name</th>
//                                 <th className="align-center">Created At</th>
//                                 <th className="align-center">Last Update</th>
//                                 <th className="align-right width-10vw">Action</th>
//                             </tr>
//                         </thead>
//                         {buffer ? <div className="spinner"></div> : //buffering logic
//                             <tbody>
//                                 {/* {projectDetail */}
//                                 {filteredProjects
//                                     ?.sort((a, b) =>
//                                         (a.project_short_name || "").localeCompare(
//                                             (b.project_short_name || ""),
//                                             "en",
//                                             { ignorePunctuation: true }
//                                         )
//                                     )
//                                     .map((i, index) => (
//                                         <React.Fragment key={i.id}>
//                                             <tr className="tr-border-bottom">
//                                                 <td colSpan="4"></td>
//                                             </tr>
//                                             <tr className="custom-table-head-td">

//                                                 <td className="align-left">{index + 1}</td>
//                                                 <td className="align-center">
//                                                     {i.sub_company_name || "-"}
//                                                 </td>
//                                                 <td className="align-center">
//                                                     {i.department_name || "-"}
//                                                 </td>

//                                                 <td className="align-center">
//                                                     {i.project_code || "-"}
//                                                 </td>
//                                                 <td className="align-center">
//                                                     <CustomTooltip
//                                                         position="top"
//                                                         tooltipContent={i.project_full_name}
//                                                     >
//                                                         <span>
//                                                             {i.project_short_name || "-"}
//                                                         </span>
//                                                     </CustomTooltip>
//                                                 </td>



//                         <td className="align-center">
//                           {i.project_type_name || "-"}
//                         </td>

//                                                 <td className="align-center">
//                                                     {i.project_client_detail?.client_name || "-"}
//                                                 </td>

//                                                 <td className="table-body align-center">
//                                                     {i.created_at ? (
//                                                         <UserProfileModal
//                                                             code={i.created_by}
//                                                             name={i.created_by_name}
//                                                             profilePic={i.created_by_profilepic}
//                                                             dateText={formatDateTime(i.created_at).shortfull}
//                                                         />
//                                                     )
//                                                         :
//                                                         <>
//                                                             {formatDateTime(i?.created_at).longdate}
//                                                             <br />
//                                                             <small>{formatDateTime(i?.created_at).time}</small>
//                                                         </>
//                                                     }
//                                                 </td>


//                                                 <td className="table-body align-center">

//                                                     {i.updated_by ? (
//                                                         <UserProfileModal
//                                                             code={i.updated_by}
//                                                             name={i.updated_by_name}
//                                                             profilePic={i.updated_by_profilepic}
//                                                             dateText={formatDateTime(i.updated_at).shortfull}
//                                                         />
//                                                     ) : (
//                                                         <>
//                                                             {formatDateTime(i.updated_at).longdate}
//                                                             <br />
//                                                             <small>{formatDateTime(i.updated_at).time}</small>
//                                                         </>
//                                                     )}
//                                                 </td>

//                                                 <td className="align-right width-5vw">
//                                                     <ProjectUpdate
//                                                         i={i}
//                                                         getProjects={getProjectDetailList}
//                                                         SUB_COMPANIES={SUB_COMPANIES}
//                                                     />
//                                                     <ProjectDelete
//                                                         i={i}
//                                                         getProjects={getProjectDetailList}
//                                                     />
//                                                 </td>

//                                             </tr>
//                                         </React.Fragment>
//                                     ))}
//                             </tbody>
//                         }
//                     </table>
//                 </div>
//             </div>
//             <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//             {/* </div> */}
//         </>

//     );
// };

// // const ProjectType = () => {
// //     const [projectTypeList, setProjectTypeList] = useState([]);
// //     const [buffer, setBuffering] = useState(true);
// //     const [searchQuery, setSearchQuery] = useState("");

// //     const { PERMISSION_AUTHORITY, PERMISSION_HR_ADMIN } = usePermission();

// //     const handleSearchChange = (e) => {
// //         setSearchQuery(e.target.value);
// //     };

// //     const getProjectTypeList = async () => {
// //         try {
// //             setBuffering(true);
// //             const res = await axios.get(`${BASE_URL}/mantra_projects/types/`);
// //             setProjectTypeList(res.data);
// //         } catch (err) {
// //             handleErrorToast(err);
// //         } finally {
// //             setBuffering(false);
// //         }
// //     };

// //     useEffect(() => {
// //         getProjectTypeList();
// //     }, []);

// //     return (
// //         <div className="content-tabs">
// //             <div className="table-css-white-background">
// //                 <div className="table-heading-flex">
// //                     <div className="repo-heading font-weight500 font-size-heading">Project Type</div>
// //                     <div className="field-cont">

// //                         {/* <div className="table-searchh">
// //                             <div>
// //                                 <svg
// //                                     xmlns="http://www.w3.org/2000/svg"
// //                                     width="11"
// //                                     height="12"
// //                                     viewBox="0 0 11 12"
// //                                     fill="none"
// //                                 >
// //                                     <circle cx="5" cy="5" r="4.3" stroke="#2B3674" strokeWidth="1.4" />
// //                                     <line
// //                                         x1="10.0101"
// //                                         y1="11"
// //                                         x2="8"
// //                                         y2="8.98995"
// //                                         stroke="#2B3674"
// //                                         strokeWidth="1.4"
// //                                         strokeLinecap="round"
// //                                     />
// //                                 </svg>
// //                             </div>
// //                             <div>
// //                                 <input
// //                                     placeholder="Search"
// //                                     className="navbar-inputt font-weight400 font-size-text"
// //                                     value={searchQuery}
// //                                     onChange={handleSearchChange}
// //                                 />
// //                             </div>
// //                         </div> */}

// //                         <ProjectTypeAdd getProjectTypeList={getProjectTypeList} />
// //                         <ProjectTypeBulkUpload getProjectTypeList={getProjectTypeList} />

// //                     </div>
// //                 </div>

// //                 <table className="table-css">
// //                     <thead>
// //                         <tr className="custom-table-head-tr">
// //                             <th className="align-left">Sr no.</th>
// //                             <th className="align-center">Project Type Name</th>
// //                             <th className="align-center">Description</th>
// //                             <th className="align-center">Created At</th>
// //                             <th className="align-center">Last Update</th>
// //                             <th className="align-right width-10vw">Action</th>
// //                         </tr>
// //                     </thead>

// //                     {buffer ? (
// //                         <div className="spinner"></div>
// //                     ) : (
// //                         <tbody>
// //                             {projectTypeList
// //                                 ?.filter((e) =>
// //                                     e.type_name.toLowerCase().includes(searchQuery.toLowerCase())
// //                                 )
// //                                 .sort((a, b) =>
// //                                     a.type_name.localeCompare(b.type_name, "en", { ignorePunctuation: true })
// //                                 )
// //                                 .map((i, index) => (
// //                                     <React.Fragment key={i.id}>
// //                                         <tr className="tr-border-bottom">
// //                                             <td colSpan="4"></td>
// //                                         </tr>
// //                                         <tr className="custom-table-head-td">
// //                                             <td className="align-left">{index + 1}</td>
// //                                             <td className="align-center">{i.type_name}</td>
// //                                             <td className="align-center">
// //                                                 {i.type_description ? i.type_description : <span className="font-size-text" style={{ color: "var(--color-text-tertiary)" }}>—</span>}
// //                                             </td>
// //                                             <td className="table-body align-center">
// //                                                 {i.created_at ? (
// //                                                     <UserProfileModal
// //                                                         code={i.created_by}
// //                                                         name={i.created_by_name}
// //                                                         profilePic={i.created_by_profilepic}
// //                                                         dateText={formatDateTime(i.created_at).shortfull}
// //                                                     />
// //                                                 )
// //                                                     :
// //                                                     <>
// //                                                         {formatDateTime(i?.created_at).longdate}
// //                                                         <br />
// //                                                         <small>{formatDateTime(i?.created_at).time}</small>
// //                                                     </>
// //                                                 }
// //                                             </td>

// //                                             <td className="table-body align-center">

// //                                                 {i.updated_by ? (
// //                                                     <UserProfileModal
// //                                                         code={i.updated_by}
// //                                                         name={i.updated_by_name}
// //                                                         profilePic={i.updated_by_profilepic}
// //                                                         dateText={formatDateTime(i.updated_at).shortfull}
// //                                                     />
// //                                                 ) : (
// //                                                     <>
// //                                                         {formatDateTime(i.updated_at).longdate}
// //                                                         <br />
// //                                                         <small>{formatDateTime(i.updated_at).time}</small>
// //                                                     </>
// //                                                 )}
// //                                             </td>
// //                                             <td className="align-right width-5vw">
// //                                                 <ProjectTypeUpdate i={i} getProjectTypeList={getProjectTypeList} />
// //                                                 <ProjectTypeDelete i={i} getProjectTypeList={getProjectTypeList} />
// //                                             </td>
// //                                         </tr>
// //                                     </React.Fragment>
// //                                 ))}
// //                         </tbody>
// //                     )}
// //                 </table>

// //                 <ToastContainer
// //                     position="top-center"
// //                     autoClose={1000}
// //                     hideProgressBar={false}
// //                     newestOnTop={true}
// //                     closeOnClick
// //                     rtl={false}
// //                     pauseOnFocusLoss
// //                     draggable
// //                     pauseOnHover
// //                 />
// //             </div>
// //         </div>
// //     );
// // };

// const ProjectType = () => {
//   const [projectTypeList, setProjectTypeList] = useState([]);
//   const [buffer, setBuffering] = useState(true);

//   const { PERMISSION_AUTHORITY, PERMISSION_HR_ADMIN } = usePermission();

//   // ================= FILTER STATE =================
//   const [projectTypeName, setProjectTypeName] = useState("");

//   const getProjectTypeList = async () => {
//     try {
//       setBuffering(true);

//       const res = await axios.get(`${BASE_URL}/mantra_projects/types/`);

//       setProjectTypeList(res.data);
//     } catch (err) {
//       handleErrorToast(err);
//     } finally {
//       setBuffering(false);
//     }
//   };

//   useEffect(() => {
//     getProjectTypeList();
//   }, []);

//   // ================= FILTERED DATA =================

//   const filteredProjectTypes = useMemo(() => {
//     let filteredData = [...projectTypeList];

//     // ================= PROJECT TYPE NAME =================
//     if (projectTypeName?.trim()) {
//       filteredData = filteredData.filter((i) =>
//         (i?.type_name || "")
//           .toLowerCase()
//           .includes(projectTypeName.toLowerCase().trim()),
//       );
//     }

//     return filteredData;
//   }, [projectTypeList, projectTypeName]);

//   return (
//     <>
//       <div className="content-tabs" style={{ margin: "10px" }}>
//         {/* ================= FILTER SECTION ================= */}
//         <div className="field-parent-cont" style={{ gap: "20px" }}>
//           <div className="field-cont">
//             {/* ================= PROJECT TYPE NAME ================= */}

//             <SearchFilterInput
//               placeholder="By Project Type Name"
//               value={projectTypeName}
//               onChange={(e) => setProjectTypeName(e.target.value)}
//               onClear={() => setProjectTypeName("")}
//               widthClass="width-16vw"
//             />
//           </div>

//           {/* RIGHT BUTTONS */}
//           <div
//             className="letter-template-btn"
//             style={{
//               display: "flex",
//               gap: "10px",
//             }}
//           >
//             <ProjectTypeAdd getProjectTypeList={getProjectTypeList} />

//             <ProjectTypeBulkUpload getProjectTypeList={getProjectTypeList} />
//           </div>
//         </div>

//         {/* ================= TABLE ================= */}
//         <div className="table-css-white-background">
//           <div className="table-heading-flex">
//             <div className="repo-heading font-weight500 font-size-heading">
//               Project Type
//             </div>
//           </div>

//           <table className="table-css">
//             <thead>
//               <tr className="custom-table-head-tr">
//                 <th className="align-left">Sr no.</th>

//                 <th className="align-center">Project Type Name</th>

//                 <th className="align-center">Description</th>

//                 <th className="align-center">Created At</th>

//                 <th className="align-center">Last Update</th>

//                 <th className="align-right width-10vw">Action</th>
//               </tr>
//             </thead>

//             {buffer ? (
//               <div className="spinner"></div>
//             ) : (
//               <tbody>
//                 {filteredProjectTypes
//                   ?.sort((a, b) =>
//                     a.type_name.localeCompare(b.type_name, "en", {
//                       ignorePunctuation: true,
//                     }),
//                   )
//                   .map((i, index) => (
//                     <React.Fragment key={i.id}>
//                       <tr className="tr-border-bottom">
//                         <td colSpan="4"></td>
//                       </tr>

//                       <tr className="custom-table-head-td">
//                         <td className="align-left">{index + 1}</td>

//                         <td className="align-center">{i.type_name}</td>

//                         <td className="align-center">
//                           {i.type_description ? (
//                             i.type_description
//                           ) : (
//                             <span
//                               className="font-size-text"
//                               style={{
//                                 color: "var(--color-text-tertiary)",
//                               }}
//                             >
//                               —
//                             </span>
//                           )}
//                         </td>

//                         <td className="table-body align-center">
//                           {i.created_at ? (
//                             <UserProfileModal
//                               code={i.created_by}
//                               name={i.created_by_name}
//                               profilePic={i.created_by_profilepic}
//                               dateText={formatDateTime(i.created_at).shortfull}
//                             />
//                           ) : (
//                             <>
//                               {formatDateTime(i?.created_at).longdate}

//                               <br />

//                               <small>
//                                 {formatDateTime(i?.created_at).time}
//                               </small>
//                             </>
//                           )}
//                         </td>

//                         <td className="table-body align-center">
//                           {i.updated_by ? (
//                             <UserProfileModal
//                               code={i.updated_by}
//                               name={i.updated_by_name}
//                               profilePic={i.updated_by_profilepic}
//                               dateText={formatDateTime(i.updated_at).shortfull}
//                             />
//                           ) : (
//                             <>
//                               {formatDateTime(i.updated_at).longdate}

//                               <br />

//                               <small>{formatDateTime(i.updated_at).time}</small>
//                             </>
//                           )}
//                         </td>

//                         <td className="align-right width-5vw">
//                           <ProjectTypeUpdate
//                             i={i}
//                             getProjectTypeList={getProjectTypeList}
//                           />

//                           <ProjectTypeDelete
//                             i={i}
//                             getProjectTypeList={getProjectTypeList}
//                           />
//                         </td>
//                       </tr>
//                     </React.Fragment>
//                   ))}
//               </tbody>
//             )}
//           </table>

//           <ToastContainer
//             position="top-center"
//             autoClose={1000}
//             hideProgressBar={false}
//             newestOnTop={true}
//             closeOnClick
//             rtl={false}
//             pauseOnFocusLoss
//             draggable
//             pauseOnHover
//           />
//         </div>
//       </div>
//     </>
//   );
// };

// // const ProjectClient = () => {
// //     const [clientList, setClientList] = useState([]);
// //     const [buffer, setBuffering] = useState(true);
// //     const [searchQuery, setSearchQuery] = useState("");

// //     const { PERMISSION_AUTHORITY, PERMISSION_HR_ADMIN } = usePermission();

// //     const handleSearchChange = (e) => {
// //         setSearchQuery(e.target.value);
// //     };

// //     const getProjectClientList = async () => {
// //         try {
// //             setBuffering(true);
// //             const res = await axios.get(`${BASE_URL}/mantra_projects/clients/`);
// //             setClientList(res.data);
// //         } catch (err) {
// //             handleErrorToast(err);
// //         } finally {
// //             setBuffering(false);
// //         }
// //     };

// //     useEffect(() => {
// //         getProjectClientList();
// //     }, []);

// //     return (
// //         <div className="content-tabs">
// //             <div className="table-css-white-background">
// //                 <div className="table-heading-flex">
// //                     <div className="repo-heading font-weight500 font-size-heading">Project Client</div>
// //                     <div className="field-cont">
// //                         {/*
// //                     <div className="table-searchh">
// //                         <div>
// //                             <svg
// //                                 xmlns="http://www.w3.org/2000/svg"
// //                                 width="11"
// //                                 height="12"
// //                                 viewBox="0 0 11 12"
// //                                 fill="none"
// //                             >
// //                                 <circle cx="5" cy="5" r="4.3" stroke="#2B3674" strokeWidth="1.4" />
// //                                 <line
// //                                     x1="10.0101"
// //                                     y1="11"
// //                                     x2="8"
// //                                     y2="8.98995"
// //                                     stroke="#2B3674"
// //                                     strokeWidth="1.4"
// //                                     strokeLinecap="round"
// //                                 />
// //                             </svg>
// //                         </div>
// //                         <div>
// //                             <input
// //                                 placeholder="Search"
// //                                 className="navbar-inputt font-weight400 font-size-text"
// //                                 value={searchQuery}
// //                                 onChange={handleSearchChange}
// //                             />
// //                         </div>
// //                     </div> */}

// //                         <ProjectClientAdd getProjectClientList={getProjectClientList} />
// //                         <ProjectClientBulkUpload getProjectClientList={getProjectClientList} />

// //                     </div>
// //                 </div>

// //                 <table className="table-css">
// //                     <thead>
// //                         <tr className="custom-table-head-tr">
// //                             <th className="align-left">Sr no.</th>
// //                             <th className="align-center">Client Name</th>
// //                             <th className="align-center">State</th>
// //                             <th className="align-center">RO</th>
// //                             <th className="align-center">Created At</th>
// //                             <th className="align-center">Last Update</th>
// //                             <th className="align-right width-10vw">Action</th>
// //                         </tr>
// //                     </thead>

// //                     {buffer ? (
// //                         <div className="spinner"></div>
// //                     ) : (
// //                         <tbody>
// //                             {clientList
// //                                 ?.filter((e) =>
// //                                     e.client_name.toLowerCase().includes(searchQuery.toLowerCase())
// //                                 )
// //                                 .sort((a, b) =>
// //                                     a.client_name.localeCompare(b.client_name, "en", { ignorePunctuation: true })
// //                                 )
// //                                 .map((i, index) => (
// //                                     <React.Fragment key={i.id}>
// //                                         <tr className="tr-border-bottom">
// //                                             <td colSpan="5"></td>
// //                                         </tr>
// //                                         <tr className="custom-table-head-td">
// //                                             <td className="align-left">{index + 1}</td>
// //                                             <td className="align-center">{i.client_name}</td>
// //                                             <td className="align-center">
// //                                                 {i.client_state || <span style={{ color: "grey" }}>—</span>}
// //                                             </td>
// //                                             <td className="align-center">
// //                                                 {i.client_ro || <span style={{ color: "grey" }}>—</span>}
// //                                             </td>
// //                                             <td className="table-body align-center">
// //                                                 {i.created_at ? (
// //                                                     <UserProfileModal
// //                                                         code={i.created_by}
// //                                                         name={i.created_by_name}
// //                                                         profilePic={i.created_by_profilepic}
// //                                                         dateText={formatDateTime(i.created_at).shortfull}
// //                                                     />
// //                                                 )
// //                                                     :
// //                                                     <>
// //                                                         {formatDateTime(i?.created_at).longdate}
// //                                                         <br />
// //                                                         <small>{formatDateTime(i?.created_at).time}</small>
// //                                                     </>
// //                                                 }
// //                                             </td>

// //                                             <td className="table-body align-center">

// //                                                 {i.updated_by ? (
// //                                                     <UserProfileModal
// //                                                         code={i.updated_by}
// //                                                         name={i.updated_by_name}
// //                                                         profilePic={i.updated_by_profilepic}
// //                                                         dateText={formatDateTime(i.updated_at).shortfull}
// //                                                     />
// //                                                 ) : (
// //                                                     <>
// //                                                         {formatDateTime(i.updated_at).longdate}
// //                                                         <br />
// //                                                         <small>{formatDateTime(i.updated_at).time}</small>
// //                                                     </>
// //                                                 )}
// //                                             </td>
// //                                             <td className="align-right width-5vw">
// //                                                 <ProjectClientUpdate i={i} getProjectClientList={getProjectClientList} />
// //                                                 <ProjectClientDelete i={i} getProjectClientList={getProjectClientList} />
// //                                             </td>
// //                                         </tr>
// //                                     </React.Fragment>
// //                                 ))}
// //                         </tbody>
// //                     )}
// //                 </table>

// //                 <ToastContainer
// //                     position="top-center"
// //                     autoClose={1000}
// //                     hideProgressBar={false}
// //                     newestOnTop={true}
// //                     closeOnClick
// //                     rtl={false}
// //                     pauseOnFocusLoss
// //                     draggable
// //                     pauseOnHover
// //                 />
// //             </div>
// //         </div>
// //     );
// // };

// const ProjectClient = () => {

//     const [clientList, setClientList] = useState([]);
//     const [buffer, setBuffering] = useState(true);

//     const { PERMISSION_AUTHORITY, PERMISSION_HR_ADMIN } = usePermission();


//     // ================= FILTER STATES =================
//     const [clientName, setClientName] = useState("");
//     const [clientState, setClientState] = useState("");
//     const [clientRO, setClientRO] = useState("");



//     const getProjectClientList = async () => {

//         try {

//             setBuffering(true);

//             const res = await axios.get(
//                 `${BASE_URL}/mantra_projects/clients/`
//             );

//             setClientList(res.data);

//         } catch (err) {

//             handleErrorToast(err);

//         } finally {

//             setBuffering(false);

//         }
//     };



//     useEffect(() => {

//         getProjectClientList();

//     }, []);


//     // ================= FILTERED DATA =================

//     const filteredClientList = useMemo(() => {

//         let filteredData = [...clientList];



//         // ================= CLIENT NAME =================
//         if (clientName?.trim()) {

//             filteredData = filteredData.filter((i) =>
//                 (i?.client_name || "")
//                     .toLowerCase()
//                     .includes(
//                         clientName.toLowerCase().trim()
//                     )
//             );

//         }



//         // ================= STATE =================
//         if (clientState?.trim()) {

//             filteredData = filteredData.filter((i) =>
//                 (i?.client_state || "")
//                     .toLowerCase()
//                     .includes(
//                         clientState.toLowerCase().trim()
//                     )
//             );

//         }



//         // ================= RO =================
//         if (clientRO?.trim()) {

//             filteredData = filteredData.filter((i) =>
//                 (i?.client_ro || "")
//                     .toLowerCase()
//                     .includes(
//                         clientRO.toLowerCase().trim()
//                     )
//             );

//         }



//         return filteredData;

//     }, [
//         clientList,
//         clientName,
//         clientState,
//         clientRO
//     ]);



//     return (

//         <>
//             <div
//                 className="content-tabs"
//                 style={{ margin: '10px' }}
//             >


//                 {/* ================= FILTER SECTION ================= */}
//                 <div className="field-parent-cont" style={{ gap: '20px' }}>

//                     <div className="field-cont">
//                         {/* ================= CLIENT NAME ================= */}
//                         <SearchFilterInput
//                             placeholder="By Client Name"
//                             value={clientName}
//                             onChange={(e) => setClientName(e.target.value)}
//                             onClear={() => setClientName("")}
//                             widthClass="width-16vw"
//                         />

//                         {/* ================= STATE ================= */}
//                         <SearchFilterInput
//                             placeholder="By State"
//                             value={clientState}
//                             onChange={(e) => setClientState(e.target.value)}
//                             onClear={() => setClientState("")}
//                             widthClass="width-14vw"
//                         />

//                         {/* ================= RO ================= */}
//                         <SearchFilterInput
//                             placeholder="By RO"
//                             value={clientRO}
//                             onChange={(e) => setClientRO(e.target.value)}
//                             onClear={() => setClientRO("")}
//                             widthClass="width-14vw"
//                         />

//                     </div>

//                     {/* RIGHT BUTTONS */}
//                     <div className="letter-template-btn" style={{ display: 'flex', gap: '10px' }}>
//                         <ProjectClientAdd getProjectClientList={() => fetchClients(1, true)} />
//                         <ProjectClientBulkUpload getProjectClientList={() => fetchClients(1, true)} />
//                     </div>
//                 </div>

//                 {/* ================= TABLE ================= */}
//                 <div className="table-css-white-background">
//                     <div className="table-heading-flex">
//                         <div className="repo-heading font-weight500 font-size-heading">
//                             Project Client
//                         </div>
//                     </div>

//                     <table className="table-css">
//                         <thead>
//                             <tr className="custom-table-head-tr">
//                                 <th className="align-left">Sr no.</th>
//                                 <th className="align-center">Client Name</th>
//                                 <th className="align-center">State</th>
//                                 <th className="align-center">RO</th>
//                                 {/* Add Client Type header here if needed */}
//                                 <th className="align-center">Created At</th>
//                                 <th className="align-center">Last Update</th>
//                                 <th className="align-right width-10vw">Action</th>
//                             </tr>
//                         </thead>

//                         {buffer && page === 1 ? (
//                             <div className="spinner"></div>
//                         ) : (
//                             <tbody>
//                                 {clientList
//                                     ?.sort((a, b) =>
//                                         a.client_name.localeCompare(b.client_name, "en", {
//                                             ignorePunctuation: true,
//                                         })
//                                     )
//                                     .map((i, index) => (
//                                         <React.Fragment key={i.id}>
//                                             <tr className="tr-border-bottom">
//                                                 <td colSpan="7"></td>
//                                             </tr>

//                                             <tr className="custom-table-head-td">

//                                                 <td className="align-left">
//                                                     {index + 1}
//                                                 </td>

//                                                 <td className="align-center">
//                                                     {i.client_state || <span style={{ color: "grey" }}>—</span>}
//                                                 </td>

//                                                 <td className="align-center">
//                                                     {i.client_ro || <span style={{ color: "grey" }}>—</span>}
//                                                 </td>

//                                                 {/* Add Client Type table data cell here if needed */}

//                                                 <td className="table-body align-center">
//                                                     {i.created_at ? (
//                                                         <UserProfileModal
//                                                             code={i.created_by}
//                                                             name={i.created_by_name}
//                                                             profilePic={i.created_by_profilepic}
//                                                             dateText={formatDateTime(i.created_at).shortfull}
//                                                         />
//                                                     ) : (
//                                                         <>
//                                                             {formatDateTime(i?.created_at).longdate}
//                                                             <br />
//                                                             <small>{formatDateTime(i?.created_at).time}</small>
//                                                         </>
//                                                     )}
//                                                 </td>

//                                                 <td className="table-body align-center">
//                                                     {i.updated_by ? (
//                                                         <UserProfileModal
//                                                             code={i.updated_by}
//                                                             name={i.updated_by_name}
//                                                             profilePic={i.updated_by_profilepic}
//                                                             dateText={formatDateTime(i.updated_at).shortfull}
//                                                         />
//                                                     ) : (
//                                                         <>
//                                                             {formatDateTime(i.updated_at).longdate}
//                                                             <br />
//                                                             <small>{formatDateTime(i.updated_at).time}</small>
//                                                         </>
//                                                     )}
//                                                 </td>

//                                                 <td className="align-right width-5vw">
//                                                     <ProjectClientUpdate
//                                                         i={i}
//                                                         getProjectClientList={() => fetchClients(1, true)}
//                                                     />
//                                                     <ProjectClientDelete
//                                                         i={i}
//                                                         getProjectClientList={() => fetchClients(1, true)}
//                                                     />
//                                                 </td>
//                                             </tr>
//                                         </React.Fragment>
//                                     ))}

//                             </tbody>
//                         )}
//                     </table>

//                     <ToastContainer
//                         position="top-center"
//                         autoClose={1000}
//                         hideProgressBar={false}
//                         newestOnTop={true}
//                         closeOnClick
//                         rtl={false}
//                         pauseOnFocusLoss
//                         draggable
//                         pauseOnHover
//                     />
//                 </div>
//             </div>
//         </>
//     );
// };

// export { ProjectDetailTable, ProjectClient, ProjectType };



import React, {
    useState, useEffect, useMemo, useRef,
    useCallback,
} from "react";
import axios from "axios";
import { BASE_URL, IMAGE_URL } from "../../config/axios";
import { CustomImageModal, CustomTooltip, handleErrorToast, SearchFilterInput, UserProfileModal } from "../CustomFunctions";
import Modal from "react-bootstrap/Modal";
import { ProjectAdd, ProjectClientAdd, ProjectClientDelete, ProjectClientUpdate, ProjectClientBulkUpload, ProjectDelete, ProjectTypeAdd, ProjectTypeDelete, ProjectTypeUpdate, ProjectTypeBulkUpload, ProjectUpdate, ProjectBulkUpload } from "./ProjectDetailsComponents";
import usePermission from "../../config/permissions";
import { ToastContainer, toast } from "react-toastify";
import UserDefaultLogo from "../UserDetails/UserDefaultLogo";
import { formatDate, formatDateTime } from "../Date";
import { SearchBig } from "../AllSvg";

// ===================== MAIN TABLE COMPONENT =====================

const ProjectDetailTable = () => {
    const [projectList, setProjectList] = useState([]);
    const [buffer, setBuffering] = useState(true);

    // ================= PAGINATION STATES =================
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [loadingMore, setLoadingMore] = useState(false);

    const { SUB_COMPANIES, PERMISSION_AUTHORITY } = usePermission();
    const [toggleDepartment, setToggleDepartment] = useState("null");
    const [departmentList, setDepartmentList] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");

    // ================= FILTER STATES =================
    const [toggleCompany, setToggleCompany] = useState(
        sessionStorage.getItem("company_id") || "null",
    );

    const [projectName, setProjectName] = useState("");
    const [projectType, setProjectType] = useState("");
    const [projectCode, setProjectCode] = useState("");
    const [clientName, setClientName] = useState("");

    const observerTarget = useRef(null);

    // ================= API CALL: FETCH & FILTER =================
    const fetchProjects = async (currentPage = 1, forceReset = false) => {
        try {
            if (currentPage === 1) {
                setBuffering(true);
            } else {
                setLoadingMore(true);
            }

            // Clean up 'null' strings to empty strings for the API query
            const compId = toggleCompany !== "null" ? toggleCompany : "";
            const deptId = toggleDepartment !== "null" ? toggleDepartment : "";

            const res = await axios.get(
                `${BASE_URL}/mantra_projects/projects/filter/?name=${projectName}&type=${projectType}&code=${projectCode}&client=${clientName}&sub_company_id=${compId}&department_id=${deptId}&page=${currentPage}&page_size=10`,
            );

            const fetchedResults = res.data.results || [];
            setTotalPages(res.data.total_pages || 1);

            if (currentPage === 1 || forceReset) {
                setProjectList(fetchedResults);
            } else {
                setProjectList((prev) => [...prev, ...fetchedResults]);
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
            setLoadingMore(false);
        }
    };

    // ================= DEBOUNCE EFFECT =================
    useEffect(() => {
        const timer = setTimeout(() => {
            // Whenever any filter state changes, reset to page 1 and fetch new data
            setPage(1);
            fetchProjects(1, true);
        }, 600); // 600ms debounce

        return () => clearTimeout(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        projectName,
        projectType,
        projectCode,
        clientName,
        toggleCompany,
        toggleDepartment,
    ]);

    // ================= FETCH NEXT PAGE =================
    useEffect(() => {
        if (page > 1) {
            fetchProjects(page, false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page]);

    // ================= INFINITE SCROLL OBSERVER =================
    const handleObserver = useCallback(
        (entries) => {
            const target = entries[0];
            if (
                target.isIntersecting &&
                !buffer &&
                !loadingMore &&
                page < totalPages
            ) {
                setPage((prevPage) => prevPage + 1);
            }
        },
        [buffer, loadingMore, page, totalPages],
    );

    useEffect(() => {
        const option = {
            root: null,
            rootMargin: "20px",
            threshold: 0,
        };
        const observer = new IntersectionObserver(handleObserver, option);
        if (observerTarget.current) {
            observer.observe(observerTarget.current);
        }
        return () => {
            if (observerTarget.current) {
                observer.unobserve(observerTarget.current);
            }
        };
    }, [handleObserver]);

    // ================= DROPDOWN HANDLERS & OPTIONS =================
    const handleCompanyChange = (e) => {
        const val = e.target.value;
        setToggleCompany(val);
        setToggleDepartment("null");
    };

    const departmentOptions = useMemo(() => {
        const seen = new Set();
        return projectList
            ?.filter((p) => p.department && p.department_name)
            ?.filter((p) => {
                if (seen.has(p.department)) return false;
                seen.add(p.department);
                return true;
            })
            .sort((a, b) => a.department_name.localeCompare(b.department_name));
    }, [projectList]);

    return (
        <>
            <div className="content-tabs" style={{ margin: "10px" }}>
                <div className="field-parent-cont" style={{ gap: "20px" }}>
                    <div className="field-cont">
                        {/* ================= SUB COMPANY ================= */}
                        {PERMISSION_AUTHORITY && (
                            <div className="field-cont-div">
                                <select
                                    onChange={handleCompanyChange}
                                    value={toggleCompany}
                                    className="attendance-input-field width-12vw"
                                >
                                    <option value="null">All Sub Companies</option>
                                    {SUB_COMPANIES.map((company) => (
                                        <option key={company.id} value={company.id}>
                                            {company.title}
                                        </option>
                                    ))}
                                </select>
                                <hr className="field-cont-hr" />
                            </div>
                        )}

                        {/* ================= DEPARTMENT ================= */}
                        <div className="field-cont-div">
                            <select
                                onChange={(e) => setToggleDepartment(e.target.value)}
                                value={toggleDepartment}
                                className="attendance-input-field width-12vw"
                            >
                                <option value="null">All Departments</option>
                                {departmentOptions.map((p) => (
                                    <option key={p.department} value={p.department}>
                                        {p.department_name}
                                    </option>
                                ))}
                            </select>
                            <hr className="field-cont-hr" />
                        </div>

                        {/* ================= PROJECT NAME ================= */}
                        <SearchFilterInput
                            placeholder="By Project Name"
                            value={projectName}
                            onChange={(e) => setProjectName(e.target.value)}
                            onClear={() => setProjectName("")}
                            widthClass="width-16vw"
                        />

                        {/* ================= PROJECT TYPE ================= */}
                        <SearchFilterInput
                            placeholder="By Project Type"
                            value={projectType}
                            onChange={(e) => setProjectType(e.target.value)}
                            onClear={() => setProjectType("")}
                            widthClass="width-14vw"
                        />

                        {/* ================= PROJECT CODE ================= */}
                        <SearchFilterInput
                            placeholder="By Project Code"
                            value={projectCode}
                            onChange={(e) => setProjectCode(e.target.value)}
                            onClear={() => setProjectCode("")}
                            widthClass="width-14vw"
                        />

                        {/* ================= CLIENT NAME ================= */}
                        <SearchFilterInput
                            placeholder="By Client Name"
                            value={clientName}
                            onChange={(e) => setClientName(e.target.value)}
                            onClear={() => setClientName("")}
                            widthClass="width-16vw"
                        />
                    </div>

                    {/* ================= RIGHT BUTTONS ================= */}
                    <div
                        className="letter-template-btn"
                        style={{ display: "flex", gap: "10px" }}
                    >
                        <ProjectAdd
                            getProjects={() => {
                                setPage(1);
                                fetchProjects(1, true);
                            }}
                            SUB_COMPANIES={SUB_COMPANIES}
                        />
                        <ProjectBulkUpload
                            getProjects={() => {
                                setPage(1);
                                fetchProjects(1, true);
                            }}
                            SUB_COMPANIES={SUB_COMPANIES}
                            selectedCompany={toggleCompany}
                        />
                    </div>
                </div>

                {/* ================= TABLE ================= */}
                <div className="table-css-white-background">
                    <div className="table-heading-flex">
                        <div className="repo-heading font-weight500 font-size-heading">
                            Project Details
                        </div>
                    </div>

                    <table className="table-css">
                        <thead>
                            <tr className="custom-table-head-tr">
                                <th className="align-left">Sr no</th>
                                <th className="align-center">Company</th>
                                <th className="align-center">Department</th>
                                <th className="align-center">Project Code</th>
                                <th className="align-center">Project Name</th>
                                <th className="align-center">Project Type</th>
                                <th className="align-center">Client Name</th>
                                <th className="align-center">Created At</th>
                                <th className="align-center">Last Update</th>
                                <th className="align-right width-10vw">Action</th>
                            </tr>
                        </thead>

                        {buffer && page === 1 ? (
                            <div className="spinner"></div>
                        ) : (
                            <tbody>
                                {projectList
                                    ?.sort((a, b) =>
                                        (a.project_short_name || "").localeCompare(
                                            b.project_short_name || "",
                                            "en",
                                            { ignorePunctuation: true },
                                        ),
                                    )
                                    .map((i, index) => (
                                        <React.Fragment key={i.id}>
                                            <tr className="tr-border-bottom">
                                                <td colSpan="10"></td>
                                            </tr>
                                            <tr className="custom-table-head-td">
                                                <td className="align-left">{index + 1}</td>
                                                <td className="align-center">
                                                    {i.sub_company_name || "-"}
                                                </td>
                                                <td className="align-center">
                                                    {i.department_name || "-"}
                                                </td>
                                                <td className="align-center">
                                                    {i.project_code || "-"}
                                                </td>

                                                <td className="align-center">
                                                    <CustomTooltip
                                                        position="top"
                                                        tooltipContent={i.project_full_name}
                                                    >
                                                        <span>{i.project_short_name || "-"}</span>
                                                    </CustomTooltip>
                                                </td>

                                                <td className="align-center">
                                                    {i.project_type_name || "-"}
                                                </td>

                                                <td className="align-center">
                                                    {i.client_name || "-"}
                                                </td>

                                                <td className="table-body align-center">
                                                    {i.created_at ? (
                                                        <UserProfileModal
                                                            code={i.created_by}
                                                            name={i.created_by_name}
                                                            profilePic={i.created_by_profilepic}
                                                            dateText={formatDateTime(i.created_at).shortfull}
                                                        />
                                                    ) : (
                                                        <>
                                                            {formatDateTime(i?.created_at).longdate}
                                                            <br />
                                                            <small>
                                                                {formatDateTime(i?.created_at).time}
                                                            </small>
                                                        </>
                                                    )}
                                                </td>

                                                <td className="table-body align-center">
                                                    {i.updated_by ? (
                                                        <UserProfileModal
                                                            code={i.updated_by}
                                                            name={i.updated_by_name}
                                                            profilePic={i.updated_by_profilepic}
                                                            dateText={formatDateTime(i.updated_at).shortfull}
                                                        />
                                                    ) : (
                                                        <>
                                                            {formatDateTime(i.updated_at).longdate}
                                                            <br />
                                                            <small>{formatDateTime(i.updated_at).time}</small>
                                                        </>
                                                    )}
                                                </td>

                                                <td className="align-right width-5vw">
                                                    <ProjectUpdate
                                                        i={i}
                                                        getProjects={() => {
                                                            setPage(1);
                                                            fetchProjects(1, true);
                                                        }}
                                                        SUB_COMPANIES={SUB_COMPANIES}
                                                    />
                                                    <ProjectDelete
                                                        i={i}
                                                        getProjects={() => {
                                                            setPage(1);
                                                            fetchProjects(1, true);
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ))}

                                {/* ================= LOADING MORE INDICATOR / OBSERVER TARGET ================= */}
                                {page < totalPages && (
                                    <tr ref={observerTarget}>
                                        <td
                                            colSpan="10"
                                            style={{ textAlign: "center", padding: "20px" }}
                                        >
                                            {loadingMore
                                                ? <div className="spinner"></div>
                                                : "Scroll for more"}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        )}
                    </table>
                </div>
            </div>

            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    );
};
// const ProjectDetailTable = () => {
//     // const [projectDetail, setProjectDetail] = useState([]);
//     const [allProjects, setAllProjects] = useState([]);
//     const { SUB_COMPANIES, PERMISSION_AUTHORITY } = usePermission();
//     const [toggleCompany, setToggleCompany] = useState("null");
//     const [buffer, setBuffering] = useState(true); //buffering logic
//     const [toggleDepartment, setToggleDepartment] = useState("null");
//     const [departmentList, setDepartmentList] = useState([]);
//     const [searchQuery, setSearchQuery] = useState("");

//     // ================= FILTER STATES =================
//     const [projectName, setProjectName] = useState("");
//     const [projectType, setProjectType] = useState("");
//     const [projectCode, setProjectCode] = useState("");
//     const [clientName, setClientName] = useState("");

//     const projectDetail = useMemo(() => {
//         if (!toggleDepartment || toggleDepartment === "null") return allProjects;
//         return allProjects.filter((p) => p.department === toggleDepartment);
//     }, [allProjects, toggleDepartment]);

//     // ================= FILTERED PROJECT DATA =================
//     // ================= FILTERED PROJECT DATA =================

//     const filteredProjects = useMemo(() => {

//         let filteredData = [...projectDetail];



//         // ================= PROJECT NAME =================
//         if (projectName?.trim()) {

//             filteredData = filteredData.filter((i) =>
//                 (i?.project_short_name || "")
//                     .toLowerCase()
//                     .includes(projectName.toLowerCase().trim())
//             );
//         }



//         // ================= PROJECT TYPE =================
//         if (projectType?.trim()) {

//             filteredData = filteredData.filter((i) =>
//                 (i?.project_type_name || "")
//                     .toLowerCase()
//                     .includes(projectType.toLowerCase().trim())
//             );
//         }



//         // ================= PROJECT CODE =================
//         if (projectCode?.trim()) {

//             filteredData = filteredData.filter((i) =>
//                 (i?.project_code || "")
//                     .toLowerCase()
//                     .includes(projectCode.toLowerCase().trim())
//             );
//         }



//         // ================= CLIENT NAME =================
//         if (clientName?.trim()) {

//             filteredData = filteredData.filter((i) =>
//                 (i?.project_client_detail?.client_name || "")
//                     .toLowerCase()
//                     .includes(clientName.toLowerCase().trim())
//             );
//         }



//         return filteredData;

//     }, [
//         projectDetail,
//         projectName,
//         projectType,
//         projectCode,
//         clientName
//     ]);


//     //  Fetch departments (filtered by sub-company if selected)
//     // const getDepartmentList = async (subCompanyId) => {
//     //     try {
//     //         const url =
//     //             subCompanyId && subCompanyId !== "null"
//     //                 ? `${BASE_URL}/wfm/departmentfilterbysubcompanycount/${subCompanyId}/active/`
//     //                 : `${BASE_URL}/wfm/departmentfilterbysubcompanycount/null/null/`;
//     //         const res = await axios.get(url);
//     //         setDepartmentList(res.data);
//     //     } catch (err) {
//     //         handleErrorToast(err);
//     //     }
//     // };
//     const getProjectDetailList = async () => {
//         try {
//             setBuffering(true);
//             const params = new URLSearchParams();
//             if (toggleCompany && toggleCompany !== "null")
//                 params.append("sub_company_id", toggleCompany);
//             // if (toggleDepartment && toggleDepartment !== "null")
//             //     params.append("department_id", toggleDepartment);

//             const res = await axios.get(
//                 `${BASE_URL}/mantra_projects/projects/${params.toString() ? `?${params.toString()}` : ""}`
//             );
//             // setProjectDetail(res.data);
//             setAllProjects(res.data);
//         } catch (err) {
//             handleErrorToast(err)
//         } finally {
//             setBuffering(false); //buffering logic // End Buffering
//         }
//     };

//     const departmentOptions = useMemo(() => {
//         const seen = new Set();
//         return allProjects
//             ?.filter((p) => p.department && p.department_name)
//             ?.filter((p) => {
//                 if (seen.has(p.department)) return false;
//                 seen.add(p.department);
//                 return true;
//             })
//             .sort((a, b) => a.department_name.localeCompare(b.department_name));
//     }, [allProjects]);


//     const handleCompanyChange = (e) => {
//         const val = e.target.value;
//         setToggleCompany(val);
//         setToggleDepartment("null");
//         // getDepartmentList(val);
//     };
//     // useEffect(() => {
//     //     getDepartmentList("null");
//     // }, [toggleCompany]);

//     useEffect(() => {
//         getProjectDetailList();
//     }, [toggleCompany]);



//     return (
//         <>
//             <div className="content-tabs" style={{ margin: '10px' }}>


//                 <div
//                     className="field-parent-cont"
//                     style={{ gap: '20px' }}
//                 >

//                     <div className="field-cont">

//                         {/* SUB COMPANY */}
//                         {PERMISSION_AUTHORITY && (

//                             <div className="field-cont-div">

//                                 <select
//                                     onChange={handleCompanyChange}
//                                     value={toggleCompany}
//                                     className="attendance-input-field width-12vw"
//                                 >

//                                     <option value="null">
//                                         All Sub Companies
//                                     </option>

//                                     {SUB_COMPANIES.map((company) => (
//                                         <option
//                                             key={company.id}
//                                             value={company.id}
//                                         >
//                                             {company.title}
//                                         </option>
//                                     ))}

//                                 </select>

//                                 <hr className="field-cont-hr" />

//                             </div>

//                         )}



//                         {/* DEPARTMENT */}
//                         <div className="field-cont-div">

//                             <select
//                                 onChange={(e) => setToggleDepartment(e.target.value)}
//                                 value={toggleDepartment}
//                                 className="attendance-input-field width-12vw"
//                             >

//                                 <option value="null">
//                                     All Departments
//                                 </option>

//                                 {departmentOptions.map((p) => (
//                                     <option
//                                         key={p.department}
//                                         value={p.department}
//                                     >
//                                         {p.department_name}
//                                     </option>
//                                 ))}

//                             </select>

//                             <hr className="field-cont-hr" />

//                         </div>



//                         {/* PROJECT NAME */}
//                         <SearchFilterInput
//                             placeholder="By Project Name"
//                             value={projectName}
//                             onChange={(e) =>
//                                 setProjectName(e.target.value)
//                             }
//                             onClear={() => setProjectName("")}
//                             widthClass="width-16vw"
//                         />



//                         {/* ================= PROJECT TYPE ================= */}

//                         <SearchFilterInput
//                             placeholder="By Project Type"
//                             value={projectType}
//                             onChange={(e) =>
//                                 setProjectType(e.target.value)
//                             }
//                             onClear={() => setProjectType("")}
//                             widthClass="width-14vw"
//                         />



//                         {/* ================= PROJECT CODE ================= */}

//                         <SearchFilterInput
//                             placeholder="By Project Code"
//                             value={projectCode}
//                             onChange={(e) =>
//                                 setProjectCode(e.target.value)
//                             }
//                             onClear={() => setProjectCode("")}
//                             widthClass="width-14vw"
//                         />



//                         {/* ================= CLIENT NAME ================= */}

//                         <SearchFilterInput
//                             placeholder="By Client Name"
//                             value={clientName}
//                             onChange={(e) =>
//                                 setClientName(e.target.value)
//                             }
//                             onClear={() => setClientName("")}
//                             widthClass="width-16vw"
//                         />

//                     </div>


//                     {/* RIGHT BUTTONS */}
//                     <div
//                         className="letter-template-btn"
//                         style={{
//                             display: 'flex',
//                             gap: '10px'
//                         }}
//                     >

//                         <ProjectAdd getProjects={getProjectDetailList} SUB_COMPANIES={SUB_COMPANIES} />

//                         {/* <ProjectBulkUpload getProjects={getProjectDetailList} SUB_COMPANIES={SUB_COMPANIES} /> */}
//                         <ProjectBulkUpload getProjects={getProjectDetailList} SUB_COMPANIES={SUB_COMPANIES} selectedCompany={toggleCompany} />

//                     </div>


//                 </div>


//                 <div className="table-css-white-background">
//                     <div className="table-heading-flex">

//                         <div className="repo-heading font-weight500 font-size-heading">
//                             Project Details
//                         </div>
//                     </div>

//                     <table className="table-css">
//                         <thead>
//                             <tr className="custom-table-head-tr">
//                                 <th className="align-left">Sr no</th>
//                                 <th className="align-center">Company</th>
//                                 <th className="align-center">Department</th>
//                                 <th className="align-center">Project Code</th>
//                                 <th className="align-center">Project Name</th>
//                                 <th className="align-center">Project Type</th>
//                                 <th className="align-center">Client Name</th>
//                                 <th className="align-center">Created At</th>
//                                 <th className="align-center">Last Update</th>
//                                 <th className="align-right width-10vw">Action</th>
//                             </tr>
//                         </thead>
//                         {buffer ? <div className="spinner"></div> : //buffering logic
//                             <tbody>
//                                 {/* {projectDetail */}
//                                 {filteredProjects
//                                     ?.sort((a, b) =>
//                                         (a.project_short_name || "").localeCompare(
//                                             (b.project_short_name || ""),
//                                             "en",
//                                             { ignorePunctuation: true }
//                                         )
//                                     )
//                                     .map((i, index) => (
//                                         <React.Fragment key={i.id}>
//                                             <tr className="tr-border-bottom">
//                                                 <td colSpan="4"></td>
//                                             </tr>
//                                             <tr className="custom-table-head-td">

//                                                 <td className="align-left">{index + 1}</td>
//                                                 <td className="align-center">
//                                                     {i.sub_company_name || "-"}
//                                                 </td>
//                                                 <td className="align-center">
//                                                     {i.department_name || "-"}
//                                                 </td>

//                                                 <td className="align-center">
//                                                     {i.project_code || "-"}
//                                                 </td>
//                                                 <td className="align-center">
//                                                     <CustomTooltip
//                                                         position="top"
//                                                         tooltipContent={i.project_full_name}
//                                                     >
//                                                         <span>
//                                                             {i.project_short_name || "-"}
//                                                         </span>
//                                                     </CustomTooltip>
//                                                 </td>



//                                                 <td className="align-center">
//                                                     {i.project_type_name || "-"}
//                                                 </td>

//                                                 <td className="align-center">
//                                                     {i.project_client_detail?.client_name || "-"}
//                                                 </td>

//                                                 <td className="table-body align-center">
//                                                     {i.created_at ? (
//                                                         <UserProfileModal
//                                                             code={i.created_by}
//                                                             name={i.created_by_name}
//                                                             profilePic={i.created_by_profilepic}
//                                                             dateText={formatDateTime(i.created_at).shortfull}
//                                                         />
//                                                     )
//                                                         :
//                                                         <>
//                                                             {formatDateTime(i?.created_at).longdate}
//                                                             <br />
//                                                             <small>{formatDateTime(i?.created_at).time}</small>
//                                                         </>
//                                                     }
//                                                 </td>


//                                                 <td className="table-body align-center">

//                                                     {i.updated_by ? (
//                                                         <UserProfileModal
//                                                             code={i.updated_by}
//                                                             name={i.updated_by_name}
//                                                             profilePic={i.updated_by_profilepic}
//                                                             dateText={formatDateTime(i.updated_at).shortfull}
//                                                         />
//                                                     ) : (
//                                                         <>
//                                                             {formatDateTime(i.updated_at).longdate}
//                                                             <br />
//                                                             <small>{formatDateTime(i.updated_at).time}</small>
//                                                         </>
//                                                     )}
//                                                 </td>

//                                                 <td className="align-right width-5vw">
//                                                     <ProjectUpdate
//                                                         i={i}
//                                                         getProjects={getProjectDetailList}
//                                                         SUB_COMPANIES={SUB_COMPANIES}
//                                                     />
//                                                     <ProjectDelete
//                                                         i={i}
//                                                         getProjects={getProjectDetailList}
//                                                     />
//                                                 </td>

//                                             </tr>
//                                         </React.Fragment>
//                                     ))}
//                             </tbody>
//                         }
//                     </table>
//                 </div>
//             </div>
//             <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//             {/* </div> */}
//         </>

//     );
// };

// const ProjectType = () => {
//     const [projectTypeList, setProjectTypeList] = useState([]);
//     const [buffer, setBuffering] = useState(true);
//     const [searchQuery, setSearchQuery] = useState("");

//     const { PERMISSION_AUTHORITY, PERMISSION_HR_ADMIN } = usePermission();

//     const handleSearchChange = (e) => {
//         setSearchQuery(e.target.value);
//     };

//     const getProjectTypeList = async () => {
//         try {
//             setBuffering(true);
//             const res = await axios.get(`${BASE_URL}/mantra_projects/types/`);
//             setProjectTypeList(res.data);
//         } catch (err) {
//             handleErrorToast(err);
//         } finally {
//             setBuffering(false);
//         }
//     };

//     useEffect(() => {
//         getProjectTypeList();
//     }, []);

//     return (
//         <div className="content-tabs">
//             <div className="table-css-white-background">
//                 <div className="table-heading-flex">
//                     <div className="repo-heading font-weight500 font-size-heading">Project Type</div>
//                     <div className="field-cont">

//                         {/* <div className="table-searchh">
//                             <div>
//                                 <svg
//                                     xmlns="http://www.w3.org/2000/svg"
//                                     width="11"
//                                     height="12"
//                                     viewBox="0 0 11 12"
//                                     fill="none"
//                                 >
//                                     <circle cx="5" cy="5" r="4.3" stroke="#2B3674" strokeWidth="1.4" />
//                                     <line
//                                         x1="10.0101"
//                                         y1="11"
//                                         x2="8"
//                                         y2="8.98995"
//                                         stroke="#2B3674"
//                                         strokeWidth="1.4"
//                                         strokeLinecap="round"
//                                     />
//                                 </svg>
//                             </div>
//                             <div>
//                                 <input
//                                     placeholder="Search"
//                                     className="navbar-inputt font-weight400 font-size-text"
//                                     value={searchQuery}
//                                     onChange={handleSearchChange}
//                                 />
//                             </div>
//                         </div> */}

//                         <ProjectTypeAdd getProjectTypeList={getProjectTypeList} />
//                         <ProjectTypeBulkUpload getProjectTypeList={getProjectTypeList} />

//                     </div>
//                 </div>

//                 <table className="table-css">
//                     <thead>
//                         <tr className="custom-table-head-tr">
//                             <th className="align-left">Sr no.</th>
//                             <th className="align-center">Project Type Name</th>
//                             <th className="align-center">Description</th>
//                             <th className="align-center">Created At</th>
//                             <th className="align-center">Last Update</th>
//                             <th className="align-right width-10vw">Action</th>
//                         </tr>
//                     </thead>

//                     {buffer ? (
//                         <div className="spinner"></div>
//                     ) : (
//                         <tbody>
//                             {projectTypeList
//                                 ?.filter((e) =>
//                                     e.type_name.toLowerCase().includes(searchQuery.toLowerCase())
//                                 )
//                                 .sort((a, b) =>
//                                     a.type_name.localeCompare(b.type_name, "en", { ignorePunctuation: true })
//                                 )
//                                 .map((i, index) => (
//                                     <React.Fragment key={i.id}>
//                                         <tr className="tr-border-bottom">
//                                             <td colSpan="4"></td>
//                                         </tr>
//                                         <tr className="custom-table-head-td">
//                                             <td className="align-left">{index + 1}</td>
//                                             <td className="align-center">{i.type_name}</td>
//                                             <td className="align-center">
//                                                 {i.type_description ? i.type_description : <span className="font-size-text" style={{ color: "var(--color-text-tertiary)" }}>—</span>}
//                                             </td>
//                                             <td className="table-body align-center">
//                                                 {i.created_at ? (
//                                                     <UserProfileModal
//                                                         code={i.created_by}
//                                                         name={i.created_by_name}
//                                                         profilePic={i.created_by_profilepic}
//                                                         dateText={formatDateTime(i.created_at).shortfull}
//                                                     />
//                                                 )
//                                                     :
//                                                     <>
//                                                         {formatDateTime(i?.created_at).longdate}
//                                                         <br />
//                                                         <small>{formatDateTime(i?.created_at).time}</small>
//                                                     </>
//                                                 }
//                                             </td>


//                                             <td className="table-body align-center">

//                                                 {i.updated_by ? (
//                                                     <UserProfileModal
//                                                         code={i.updated_by}
//                                                         name={i.updated_by_name}
//                                                         profilePic={i.updated_by_profilepic}
//                                                         dateText={formatDateTime(i.updated_at).shortfull}
//                                                     />
//                                                 ) : (
//                                                     <>
//                                                         {formatDateTime(i.updated_at).longdate}
//                                                         <br />
//                                                         <small>{formatDateTime(i.updated_at).time}</small>
//                                                     </>
//                                                 )}
//                                             </td>
//                                             <td className="align-right width-5vw">
//                                                 <ProjectTypeUpdate i={i} getProjectTypeList={getProjectTypeList} />
//                                                 <ProjectTypeDelete i={i} getProjectTypeList={getProjectTypeList} />
//                                             </td>
//                                         </tr>
//                                     </React.Fragment>
//                                 ))}
//                         </tbody>
//                     )}
//                 </table>

//                 <ToastContainer
//                     position="top-center"
//                     autoClose={1000}
//                     hideProgressBar={false}
//                     newestOnTop={true}
//                     closeOnClick
//                     rtl={false}
//                     pauseOnFocusLoss
//                     draggable
//                     pauseOnHover
//                 />
//             </div>
//         </div>
//     );
// };

const ProjectType = () => {

    const [projectTypeList, setProjectTypeList] = useState([]);
    const [buffer, setBuffering] = useState(true);

    const { PERMISSION_AUTHORITY, PERMISSION_HR_ADMIN } = usePermission();

    // ================= FILTER STATE =================
    const [projectTypeName, setProjectTypeName] = useState("");



    const getProjectTypeList = async () => {

        try {

            setBuffering(true);

            const res = await axios.get(
                `${BASE_URL}/mantra_projects/types/`
            );

            setProjectTypeList(res.data);

        } catch (err) {

            handleErrorToast(err);

        } finally {

            setBuffering(false);

        }
    };



    useEffect(() => {

        getProjectTypeList();

    }, []);



    // ================= FILTERED DATA =================

    const filteredProjectTypes = useMemo(() => {

        let filteredData = [...projectTypeList];



        // ================= PROJECT TYPE NAME =================
        if (projectTypeName?.trim()) {

            filteredData = filteredData.filter((i) =>
                (i?.type_name || "")
                    .toLowerCase()
                    .includes(
                        projectTypeName.toLowerCase().trim()
                    )
            );

        }



        return filteredData;

    }, [
        projectTypeList,
        projectTypeName
    ]);



    return (

        <>
            <div
                className="content-tabs"
                style={{ margin: '10px' }}
            >

                {/* ================= FILTER SECTION ================= */}
                <div
                    className="field-parent-cont"
                    style={{ gap: '20px' }}
                >

                    <div className="field-cont">

                        {/* ================= PROJECT TYPE NAME ================= */}

                        <SearchFilterInput
                            placeholder="By Project Type Name"
                            value={projectTypeName}
                            onChange={(e) =>
                                setProjectTypeName(e.target.value)
                            }
                            onClear={() => setProjectTypeName("")}
                            widthClass="width-16vw"
                        />

                    </div>



                    {/* RIGHT BUTTONS */}
                    <div
                        className="letter-template-btn"
                        style={{
                            display: 'flex',
                            gap: '10px'
                        }}
                    >

                        <ProjectTypeAdd
                            getProjectTypeList={getProjectTypeList}
                        />

                        <ProjectTypeBulkUpload
                            getProjectTypeList={getProjectTypeList}
                        />

                    </div>

                </div>



                {/* ================= TABLE ================= */}
                <div className="table-css-white-background">

                    <div className="table-heading-flex">

                        <div className="repo-heading font-weight500 font-size-heading">
                            Project Type
                        </div>

                    </div>

                    <table className="table-css">

                        <thead>

                            <tr className="custom-table-head-tr">

                                <th className="align-left">
                                    Sr no.
                                </th>

                                <th className="align-center">
                                    Project Type Name
                                </th>

                                <th className="align-center">
                                    Description
                                </th>

                                <th className="align-center">
                                    Created At
                                </th>

                                <th className="align-center">
                                    Last Update
                                </th>

                                <th className="align-right width-10vw">
                                    Action
                                </th>

                            </tr>

                        </thead>

                        {buffer ? (

                            <div className="spinner"></div>

                        ) : (

                            <tbody>

                                {filteredProjectTypes
                                    ?.sort((a, b) =>
                                        a.type_name.localeCompare(
                                            b.type_name,
                                            "en",
                                            { ignorePunctuation: true }
                                        )
                                    )
                                    .map((i, index) => (

                                        <React.Fragment key={i.id}>

                                            <tr className="tr-border-bottom">
                                                <td colSpan="4"></td>
                                            </tr>

                                            <tr className="custom-table-head-td">

                                                <td className="align-left">
                                                    {index + 1}
                                                </td>

                                                <td className="align-center">
                                                    {i.type_name}
                                                </td>

                                                <td className="align-center">

                                                    {i.type_description
                                                        ? i.type_description
                                                        : (
                                                            <span
                                                                className="font-size-text"
                                                                style={{
                                                                    color: "var(--color-text-tertiary)"
                                                                }}
                                                            >
                                                                —
                                                            </span>
                                                        )
                                                    }

                                                </td>

                                                <td className="table-body align-center">

                                                    {i.created_at ? (

                                                        <UserProfileModal
                                                            code={i.created_by}
                                                            name={i.created_by_name}
                                                            profilePic={i.created_by_profilepic}
                                                            dateText={formatDateTime(i.created_at).shortfull}
                                                        />

                                                    ) : (

                                                        <>
                                                            {formatDateTime(i?.created_at).longdate}

                                                            <br />

                                                            <small>
                                                                {formatDateTime(i?.created_at).time}
                                                            </small>
                                                        </>

                                                    )}

                                                </td>



                                                <td className="table-body align-center">

                                                    {i.updated_by ? (

                                                        <UserProfileModal
                                                            code={i.updated_by}
                                                            name={i.updated_by_name}
                                                            profilePic={i.updated_by_profilepic}
                                                            dateText={formatDateTime(i.updated_at).shortfull}
                                                        />

                                                    ) : (

                                                        <>
                                                            {formatDateTime(i.updated_at).longdate}

                                                            <br />

                                                            <small>
                                                                {formatDateTime(i.updated_at).time}
                                                            </small>
                                                        </>

                                                    )}

                                                </td>

                                                <td className="align-right width-5vw">

                                                    <ProjectTypeUpdate
                                                        i={i}
                                                        getProjectTypeList={getProjectTypeList}
                                                    />

                                                    <ProjectTypeDelete
                                                        i={i}
                                                        getProjectTypeList={getProjectTypeList}
                                                    />

                                                </td>

                                            </tr>

                                        </React.Fragment>

                                    ))}

                            </tbody>

                        )}

                    </table>

                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />

                </div>

            </div>
        </>

    );
};

// const ProjectClient = () => {
//     const [clientList, setClientList] = useState([]);
//     const [buffer, setBuffering] = useState(true);
//     const [searchQuery, setSearchQuery] = useState("");

//     const { PERMISSION_AUTHORITY, PERMISSION_HR_ADMIN } = usePermission();

//     const handleSearchChange = (e) => {
//         setSearchQuery(e.target.value);
//     };

//     const getProjectClientList = async () => {
//         try {
//             setBuffering(true);
//             const res = await axios.get(`${BASE_URL}/mantra_projects/clients/`);
//             setClientList(res.data);
//         } catch (err) {
//             handleErrorToast(err);
//         } finally {
//             setBuffering(false);
//         }
//     };

//     useEffect(() => {
//         getProjectClientList();
//     }, []);

//     return (
//         <div className="content-tabs">
//             <div className="table-css-white-background">
//                 <div className="table-heading-flex">
//                     <div className="repo-heading font-weight500 font-size-heading">Project Client</div>
//                     <div className="field-cont">
//                         {/* 
//                     <div className="table-searchh">
//                         <div>
//                             <svg
//                                 xmlns="http://www.w3.org/2000/svg"
//                                 width="11"
//                                 height="12"
//                                 viewBox="0 0 11 12"
//                                 fill="none"
//                             >
//                                 <circle cx="5" cy="5" r="4.3" stroke="#2B3674" strokeWidth="1.4" />
//                                 <line
//                                     x1="10.0101"
//                                     y1="11"
//                                     x2="8"
//                                     y2="8.98995"
//                                     stroke="#2B3674"
//                                     strokeWidth="1.4"
//                                     strokeLinecap="round"
//                                 />
//                             </svg>
//                         </div>
//                         <div>
//                             <input
//                                 placeholder="Search"
//                                 className="navbar-inputt font-weight400 font-size-text"
//                                 value={searchQuery}
//                                 onChange={handleSearchChange}
//                             />
//                         </div>
//                     </div> */}

//                         <ProjectClientAdd getProjectClientList={getProjectClientList} />
//                         <ProjectClientBulkUpload getProjectClientList={getProjectClientList} />

//                     </div>
//                 </div>

//                 <table className="table-css">
//                     <thead>
//                         <tr className="custom-table-head-tr">
//                             <th className="align-left">Sr no.</th>
//                             <th className="align-center">Client Name</th>
//                             <th className="align-center">State</th>
//                             <th className="align-center">RO</th>
//                             <th className="align-center">Created At</th>
//                             <th className="align-center">Last Update</th>
//                             <th className="align-right width-10vw">Action</th>
//                         </tr>
//                     </thead>

//                     {buffer ? (
//                         <div className="spinner"></div>
//                     ) : (
//                         <tbody>
//                             {clientList
//                                 ?.filter((e) =>
//                                     e.client_name.toLowerCase().includes(searchQuery.toLowerCase())
//                                 )
//                                 .sort((a, b) =>
//                                     a.client_name.localeCompare(b.client_name, "en", { ignorePunctuation: true })
//                                 )
//                                 .map((i, index) => (
//                                     <React.Fragment key={i.id}>
//                                         <tr className="tr-border-bottom">
//                                             <td colSpan="5"></td>
//                                         </tr>
//                                         <tr className="custom-table-head-td">
//                                             <td className="align-left">{index + 1}</td>
//                                             <td className="align-center">{i.client_name}</td>
//                                             <td className="align-center">
//                                                 {i.client_state || <span style={{ color: "grey" }}>—</span>}
//                                             </td>
//                                             <td className="align-center">
//                                                 {i.client_ro || <span style={{ color: "grey" }}>—</span>}
//                                             </td>
//                                             <td className="table-body align-center">
//                                                 {i.created_at ? (
//                                                     <UserProfileModal
//                                                         code={i.created_by}
//                                                         name={i.created_by_name}
//                                                         profilePic={i.created_by_profilepic}
//                                                         dateText={formatDateTime(i.created_at).shortfull}
//                                                     />
//                                                 )
//                                                     :
//                                                     <>
//                                                         {formatDateTime(i?.created_at).longdate}
//                                                         <br />
//                                                         <small>{formatDateTime(i?.created_at).time}</small>
//                                                     </>
//                                                 }
//                                             </td>


//                                             <td className="table-body align-center">

//                                                 {i.updated_by ? (
//                                                     <UserProfileModal
//                                                         code={i.updated_by}
//                                                         name={i.updated_by_name}
//                                                         profilePic={i.updated_by_profilepic}
//                                                         dateText={formatDateTime(i.updated_at).shortfull}
//                                                     />
//                                                 ) : (
//                                                     <>
//                                                         {formatDateTime(i.updated_at).longdate}
//                                                         <br />
//                                                         <small>{formatDateTime(i.updated_at).time}</small>
//                                                     </>
//                                                 )}
//                                             </td>
//                                             <td className="align-right width-5vw">
//                                                 <ProjectClientUpdate i={i} getProjectClientList={getProjectClientList} />
//                                                 <ProjectClientDelete i={i} getProjectClientList={getProjectClientList} />
//                                             </td>
//                                         </tr>
//                                     </React.Fragment>
//                                 ))}
//                         </tbody>
//                     )}
//                 </table>

//                 <ToastContainer
//                     position="top-center"
//                     autoClose={1000}
//                     hideProgressBar={false}
//                     newestOnTop={true}
//                     closeOnClick
//                     rtl={false}
//                     pauseOnFocusLoss
//                     draggable
//                     pauseOnHover
//                 />
//             </div>
//         </div>
//     );
// };

// const ProjectClient = () => {

//     const [clientList, setClientList] = useState([]);
//     const [buffer, setBuffering] = useState(true);

//     const { PERMISSION_AUTHORITY, PERMISSION_HR_ADMIN } = usePermission();


//     // ================= FILTER STATES =================
//     const [clientName, setClientName] = useState("");
//     const [clientState, setClientState] = useState("");
//     const [clientRO, setClientRO] = useState("");



//     const getProjectClientList = async () => {

//         try {

//             setBuffering(true);

//             const res = await axios.get(
//                 `${BASE_URL}/mantra_projects/clients/`
//             );

//             setClientList(res.data);

//         } catch (err) {

//             handleErrorToast(err);

//         } finally {

//             setBuffering(false);

//         }
//     };



//     useEffect(() => {

//         getProjectClientList();

//     }, []);


//     // ================= FILTERED DATA =================

//     const filteredClientList = useMemo(() => {

//         let filteredData = [...clientList];



//         // ================= CLIENT NAME =================
//         if (clientName?.trim()) {

//             filteredData = filteredData.filter((i) =>
//                 (i?.client_name || "")
//                     .toLowerCase()
//                     .includes(
//                         clientName.toLowerCase().trim()
//                     )
//             );

//         }



//         // ================= STATE =================
//         if (clientState?.trim()) {

//             filteredData = filteredData.filter((i) =>
//                 (i?.client_state || "")
//                     .toLowerCase()
//                     .includes(
//                         clientState.toLowerCase().trim()
//                     )
//             );

//         }



//         // ================= RO =================
//         if (clientRO?.trim()) {

//             filteredData = filteredData.filter((i) =>
//                 (i?.client_ro || "")
//                     .toLowerCase()
//                     .includes(
//                         clientRO.toLowerCase().trim()
//                     )
//             );

//         }



//         return filteredData;

//     }, [
//         clientList,
//         clientName,
//         clientState,
//         clientRO
//     ]);



//     return (

//         <>
//             <div
//                 className="content-tabs"
//                 style={{ margin: '10px' }}
//             >


//                 {/* ================= FILTER SECTION ================= */}
//                 <div
//                     className="field-parent-cont"
//                     style={{ gap: '20px' }}
//                 >

//                     <div className="field-cont">

//                         {/* ================= CLIENT NAME ================= */}

//                         <SearchFilterInput
//                             placeholder="By Client Name"
//                             value={clientName}
//                             onChange={(e) =>
//                                 setClientName(e.target.value)
//                             }
//                             onClear={() => setClientName("")}
//                             widthClass="width-16vw"
//                         />



//                         {/* ================= STATE ================= */}

//                         <SearchFilterInput
//                             placeholder="By State"
//                             value={clientState}
//                             onChange={(e) =>
//                                 setClientState(e.target.value)
//                             }
//                             onClear={() => setClientState("")}
//                             widthClass="width-14vw"
//                         />



//                         {/* ================= RO ================= */}

//                         <SearchFilterInput
//                             placeholder="By RO"
//                             value={clientRO}
//                             onChange={(e) =>
//                                 setClientRO(e.target.value)
//                             }
//                             onClear={() => setClientRO("")}
//                             widthClass="width-14vw"
//                         />
//                     </div>



//                     {/* RIGHT BUTTONS */}
//                     <div
//                         className="letter-template-btn"
//                         style={{
//                             display: 'flex',
//                             gap: '10px'
//                         }}
//                     >

//                         <ProjectClientAdd
//                             getProjectClientList={getProjectClientList}
//                         />

//                         <ProjectClientBulkUpload
//                             getProjectClientList={getProjectClientList}
//                         />

//                     </div>

//                 </div>



//                 {/* ================= TABLE ================= */}
//                 <div className="table-css-white-background">

//                     <div className="table-heading-flex">

//                         <div className="repo-heading font-weight500 font-size-heading">
//                             Project Client
//                         </div>

//                     </div>

//                     <table className="table-css">

//                         <thead>

//                             <tr className="custom-table-head-tr">

//                                 <th className="align-left">
//                                     Sr no.
//                                 </th>

//                                 <th className="align-center">
//                                     Client Name
//                                 </th>

//                                 <th className="align-center">
//                                     State
//                                 </th>

//                                 <th className="align-center">
//                                     RO
//                                 </th>

//                                 <th className="align-center">
//                                     Created At
//                                 </th>

//                                 <th className="align-center">
//                                     Last Update
//                                 </th>

//                                 <th className="align-right width-10vw">
//                                     Action
//                                 </th>

//                             </tr>

//                         </thead>

//                         {buffer ? (

//                             <div className="spinner"></div>

//                         ) : (

//                             <tbody>

//                                 {filteredClientList
//                                     ?.sort((a, b) =>
//                                         a.client_name.localeCompare(
//                                             b.client_name,
//                                             "en",
//                                             { ignorePunctuation: true }
//                                         )
//                                     )
//                                     .map((i, index) => (

//                                         <React.Fragment key={i.id}>

//                                             <tr className="tr-border-bottom">
//                                                 <td colSpan="5"></td>
//                                             </tr>

//                                             <tr className="custom-table-head-td">

//                                                 <td className="align-left">
//                                                     {index + 1}
//                                                 </td>

//                                                 <td className="align-center">
//                                                     {i.client_name}
//                                                 </td>

//                                                 <td className="align-center">

//                                                     {i.client_state || (
//                                                         <span style={{ color: "grey" }}>
//                                                             —
//                                                         </span>
//                                                     )}

//                                                 </td>

//                                                 <td className="align-center">

//                                                     {i.client_ro || (
//                                                         <span style={{ color: "grey" }}>
//                                                             —
//                                                         </span>
//                                                     )}

//                                                 </td>

//                                                 <td className="table-body align-center">

//                                                     {i.created_at ? (

//                                                         <UserProfileModal
//                                                             code={i.created_by}
//                                                             name={i.created_by_name}
//                                                             profilePic={i.created_by_profilepic}
//                                                             dateText={formatDateTime(i.created_at).shortfull}
//                                                         />

//                                                     ) : (

//                                                         <>
//                                                             {formatDateTime(i?.created_at).longdate}

//                                                             <br />

//                                                             <small>
//                                                                 {formatDateTime(i?.created_at).time}
//                                                             </small>
//                                                         </>

//                                                     )}

//                                                 </td>



//                                                 <td className="table-body align-center">

//                                                     {i.updated_by ? (

//                                                         <UserProfileModal
//                                                             code={i.updated_by}
//                                                             name={i.updated_by_name}
//                                                             profilePic={i.updated_by_profilepic}
//                                                             dateText={formatDateTime(i.updated_at).shortfull}
//                                                         />

//                                                     ) : (

//                                                         <>
//                                                             {formatDateTime(i.updated_at).longdate}

//                                                             <br />

//                                                             <small>
//                                                                 {formatDateTime(i.updated_at).time}
//                                                             </small>
//                                                         </>

//                                                     )}

//                                                 </td>

//                                                 <td className="align-right width-5vw">

//                                                     <ProjectClientUpdate
//                                                         i={i}
//                                                         getProjectClientList={getProjectClientList}
//                                                     />

//                                                     <ProjectClientDelete
//                                                         i={i}
//                                                         getProjectClientList={getProjectClientList}
//                                                     />

//                                                 </td>

//                                             </tr>

//                                         </React.Fragment>

//                                     ))}

//                             </tbody>

//                         )}

//                     </table>

//                     <ToastContainer
//                         position="top-center"
//                         autoClose={1000}
//                         hideProgressBar={false}
//                         newestOnTop={true}
//                         closeOnClick
//                         rtl={false}
//                         pauseOnFocusLoss
//                         draggable
//                         pauseOnHover
//                     />

//                 </div>

//             </div>
//         </>

//     );
// };


const ProjectClient = () => {
    const [clientList, setClientList] = useState([]);
    const [buffer, setBuffering] = useState(false);

    // ================= PAGINATION STATES =================
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [loadingMore, setLoadingMore] = useState(false);

    const { PERMISSION_AUTHORITY, PERMISSION_HR_ADMIN } = usePermission();

    // ================= FILTER STATES =================
    const [clientName, setClientName] = useState("");
    const [clientState, setClientState] = useState("");
    const [clientRO, setClientRO] = useState("");

    const observerTarget = useRef(null);

    // ================= UNIFIED API CALL =================
    const fetchClients = async (currentPage = 1, forceReset = false) => {
        try {
            if (currentPage === 1) {
                setBuffering(true);
            } else {
                setLoadingMore(true);
            }

            // Assuming your backend uses this combined endpoint structure
            const res = await axios.get(
                `${BASE_URL}/mantra_projects/project-clients-filter-with-pagination/?name=${clientName}&state=${clientState}&ro=${clientRO}&page=${currentPage}&page_size=10`
            );

            const fetchedResults = res.data.results || [];
            setTotalPages(res.data.total_pages || 1);

            if (currentPage === 1 || forceReset) {
                setClientList(fetchedResults);
            } else {
                setClientList((prev) => [...prev, ...fetchedResults]);
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
            setLoadingMore(false);
        }
    };

    // ================= DEBOUNCE EFFECT FOR FILTERS =================
    useEffect(() => {
        const timer = setTimeout(() => {
            // Whenever any filter changes, reset to page 1 and fetch new data
            setPage(1);
            fetchClients(1, true);
        }, 600); // 600ms delay

        return () => clearTimeout(timer);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clientName, clientState, clientRO]);


    // ================= FETCH NEXT PAGE =================
    useEffect(() => {
        if (page > 1) {
            fetchClients(page, false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page]);


    // ================= INFINITE SCROLL OBSERVER =================
    const handleObserver = useCallback(
        (entries) => {
            const target = entries[0];
            if (target.isIntersecting && !buffer && !loadingMore && page < totalPages) {
                setPage((prevPage) => prevPage + 1);
            }
        },
        [buffer, loadingMore, page, totalPages]
    );

    useEffect(() => {
        const option = {
            root: null,
            rootMargin: "20px",
            threshold: 0,
        };
        const observer = new IntersectionObserver(handleObserver, option);
        if (observerTarget.current) {
            observer.observe(observerTarget.current);
        }
        return () => {
            if (observerTarget.current) {
                observer.unobserve(observerTarget.current);
            }
        };
    }, [handleObserver]);


    return (
        <>
            <div className="content-tabs" style={{ margin: '10px' }}>

                {/* ================= FILTER SECTION ================= */}
                <div className="field-parent-cont" style={{ gap: '20px' }}>

                    <div className="field-cont">
                        {/* ================= CLIENT NAME ================= */}
                        <SearchFilterInput
                            placeholder="By Client Name"
                            value={clientName}
                            onChange={(e) => setClientName(e.target.value)}
                            onClear={() => setClientName("")}
                            widthClass="width-16vw"
                        />

                        {/* ================= STATE ================= */}
                        <SearchFilterInput
                            placeholder="By State"
                            value={clientState}
                            onChange={(e) => setClientState(e.target.value)}
                            onClear={() => setClientState("")}
                            widthClass="width-14vw"
                        />

                        {/* ================= RO ================= */}
                        <SearchFilterInput
                            placeholder="By RO"
                            value={clientRO}
                            onChange={(e) => setClientRO(e.target.value)}
                            onClear={() => setClientRO("")}
                            widthClass="width-14vw"
                        />

                    </div>

                    {/* RIGHT BUTTONS */}
                    <div className="letter-template-btn" style={{ display: 'flex', gap: '10px' }}>
                        <ProjectClientAdd getProjectClientList={() => fetchClients(1, true)} />
                        <ProjectClientBulkUpload getProjectClientList={() => fetchClients(1, true)} />
                    </div>
                </div>

                {/* ================= TABLE ================= */}
                <div className="table-css-white-background">
                    <div className="table-heading-flex">
                        <div className="repo-heading font-weight500 font-size-heading">
                            Project Client
                        </div>
                    </div>

                    <table className="table-css">
                        <thead>
                            <tr className="custom-table-head-tr">
                                <th className="align-left">Sr no.</th>
                                <th className="align-center">Client Name</th>
                                <th className="align-center">State</th>
                                <th className="align-center">RO</th>
                                {/* Add Client Type header here if needed */}
                                <th className="align-center">Created At</th>
                                <th className="align-center">Last Update</th>
                                <th className="align-right width-10vw">Action</th>
                            </tr>
                        </thead>

                        {buffer && page === 1 ? (
                            <div className="spinner"></div>
                        ) : (
                            <tbody>
                                {clientList
                                    ?.sort((a, b) =>
                                        a.client_name.localeCompare(b.client_name, "en", {
                                            ignorePunctuation: true,
                                        })
                                    )
                                    .map((i, index) => (
                                        <React.Fragment key={i.id}>
                                            <tr className="tr-border-bottom">
                                                <td colSpan="7"></td>
                                            </tr>

                                            <tr className="custom-table-head-td">
                                                <td className="align-left">{index + 1}</td>
                                                <td className="align-center">{i.client_name}</td>

                                                <td className="align-center">
                                                    {i.client_state || <span style={{ color: "grey" }}>—</span>}
                                                </td>

                                                <td className="align-center">
                                                    {i.client_ro || <span style={{ color: "grey" }}>—</span>}
                                                </td>

                                                {/* Add Client Type table data cell here if needed */}

                                                <td className="table-body align-center">
                                                    {i.created_at ? (
                                                        <UserProfileModal
                                                            code={i.created_by}
                                                            name={i.created_by_name}
                                                            profilePic={i.created_by_profilepic}
                                                            dateText={formatDateTime(i.created_at).shortfull}
                                                        />
                                                    ) : (
                                                        <>
                                                            {formatDateTime(i?.created_at).longdate}
                                                            <br />
                                                            <small>{formatDateTime(i?.created_at).time}</small>
                                                        </>
                                                    )}
                                                </td>

                                                <td className="table-body align-center">
                                                    {i.updated_by ? (
                                                        <UserProfileModal
                                                            code={i.updated_by}
                                                            name={i.updated_by_name}
                                                            profilePic={i.updated_by_profilepic}
                                                            dateText={formatDateTime(i.updated_at).shortfull}
                                                        />
                                                    ) : (
                                                        <>
                                                            {formatDateTime(i.updated_at).longdate}
                                                            <br />
                                                            <small>{formatDateTime(i.updated_at).time}</small>
                                                        </>
                                                    )}
                                                </td>

                                                <td className="align-right width-5vw">
                                                    <ProjectClientUpdate
                                                        i={i}
                                                        getProjectClientList={() => fetchClients(1, true)}
                                                    />
                                                    <ProjectClientDelete
                                                        i={i}
                                                        getProjectClientList={() => fetchClients(1, true)}
                                                    />
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ))}

                                {/* ================= LOADING MORE INDICATOR / OBSERVER TARGET ================= */}
                                {page < totalPages && (
                                    <tr ref={observerTarget}>
                                        <td colSpan="7" style={{ textAlign: 'center', padding: '20px' }}>
                                            {loadingMore ? <div className="spinner"></div>
                                                : "Scroll for more"}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        )}
                    </table>

                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </div>
            </div>
        </>
    );
};

export { ProjectDetailTable, ProjectClient, ProjectType }; 